import React, { useState } from 'react';

import style from './PortletAccordion.scss';

export const PortletAccordion = ({
    children,
    portlet
}) => {
    const [show, setShow] = useState(false);

    const showComponent = () => setShow(!show);

    return <div className={style.container}>
        <div className={`${style.title} ${show ? style.expanded : ''}`} onClick={showComponent}>{portlet?.title}</div>
        <div className={`${style.portletContainer} ${show ? '' : 'hidden'}`}>
            {children}
        </div>
    </div>;
};
